/**
 * Fetch browser safe config from the server
 * @module services/config
 */
import { fromJS, Map } from 'immutable'
import request from '../request'

/**
 * Get browser safe config from the server
 * @returns {Promise<import('immutable').Map>} The config as an immutable map
 */
export async function getConfig () {
  const { body = {} } = await request
    .get('/v1/config')
    .set('accept', 'json')
  return fromJS(body)
}

/**
 * Get the config state get the data server entry for
 * the provided key
 * @param {Map} config The config
 * @param {String} key The key to get from data server
 * @returns {String} The server string
 */
export function getConfigDataServer (config, key = 'brooklyn') {
  if (!Map.isMap(config)) {
    throw new Error('The config argument is required to be a Map')
  }
  return config.getIn(['data', 'servers', key])
}
